import { merge } from 'lodash'
import message from '@src/lang/vi/default.json'
import oherMessage from '@src/lang/vi/other.json'
import vuetifyEnMessage from 'vuetify/es5/locale/en'
import vuetifyMessage from '@src/lang/vi/vuetify.json'

let trans = merge(message, oherMessage, {
  $vuetify: { ...vuetifyEnMessage, ...vuetifyMessage },
})
const requireTrans = require.context(
  '.',
  true,
  /^((?!default|other|$vuetify).)*.json$/
)

requireTrans.keys().forEach((fileName) => {
  const transFile = requireTrans(fileName)
  const keyTrans = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')
  trans = merge(trans, { [keyTrans]: transFile })
})

export default trans
